module.exports = __webpack_public_path__ + "static/media/choithramsVegetarianism.4016556f.png";